// QuizNavbar.tsx
import { BookOpen, Trophy } from "lucide-react";
import { QuizTopic } from "./types";

interface QuizNavbarProps {
  selectedTopic: QuizTopic;
  studentName: string;
  onChangeTopic: () => void;
}

export const QuizNavbar = ({ selectedTopic, studentName, onChangeTopic }: QuizNavbarProps) => (
  <nav className="sticky top-0 z-20 backdrop-blur-xl bg-white/80 border-b border-white/40">
    <div className="h-16 max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between">
      <div className="flex items-center gap-4">
        <div className={`w-11 h-11 rounded-2xl flex items-center justify-center text-white shadow-lg ${selectedTopic.color}`}>
          <BookOpen size={20} />
        </div>
        <div>
          <h1 className="font-bold text-lg leading-tight">{selectedTopic.title}</h1>
          <p className="text-xs text-gray-500">Islamic Quiz Platform</p>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <div className="hidden md:flex items-center gap-2 px-4 py-2 rounded-2xl bg-white border shadow-sm">
          <Trophy size={16} className="text-yellow-500" />
          <span className="text-sm font-medium">Pass: {selectedTopic.passingPercentage}%</span>
        </div>

        <div className="flex items-center gap-3 px-3 py-2 rounded-2xl bg-white border shadow-sm">
          <div className="w-10 h-10 rounded-xl bg-black text-white flex items-center justify-center font-bold">
            {studentName.charAt(0).toUpperCase()}
          </div>
          <div>
            <p className="font-semibold text-sm">{studentName}</p>
            <button onClick={onChangeTopic} className="text-xs text-red-500 hover:underline">
              Change Topic
            </button>
          </div>
        </div>
      </div>
    </div>
  </nav>
);